import $ from 'jquery';
window.$ = window.jQuery = $;
import PageCarousel from './js/page-carousel';

import 'bootstrap/js/dist/util';
import 'bootstrap/js/dist/collapse';

import './scss/app.scss';

$(document).ready(() => {
  PageCarousel();
  // const myLazyLoad = new LazyLoad({
  //   elements_selector: ".lazy, .product-image-wrap .wp-post-image",
  // });
});
